<template>
  <div class="loginPage">
    <div class="trueLoginComponent">
			<v-row v-if="showGovernmentShutdownBanner">
				<v-col md="12">
					<banner-government-shutdown></banner-government-shutdown>
				</v-col>
			</v-row>
      <v-row>
        <v-col md="4">
          <login-form></login-form>
        </v-col>
        <v-col md="8">
          <v-row class="text-left loginRow">
            <p>
              Welcome to the ASA24 Researcher Website. This website allows
              researchers, clinicians, and teachers to register a study, set
              study parameters, manage study logistics, and obtain dietary
              analyses. To get started, either sign in with your existing
              username and password or create a researcher account using the
              button to the left.
            </p>
          </v-row>
          <v-row class="text-left loginRow"
            >General information on ASA24 and its features can be found at&nbsp;<a href="http://epi.grants.cancer.gov/asa24/" target="_blank" aria-label="http://epi.grants.cancer.gov/asa24/ - New Window">
             http://epi.grants.cancer.gov/asa24/</a>.
					</v-row>
          <v-row>
            <v-card class="loginCard">
              <v-list-item-title class="headline mb-1">
                Resources
              </v-list-item-title>
              <v-divider></v-divider>
							<v-row>
								<v-col class="text-left resourcesCol">
									<!-- <p><a href="file://westat.com/dfs/ASA24MTN/Researcher%20Website/Researcher%20Instructions/New%20Quick%20Guide%20and%20Links/About-ASA24.pdf" download>About ASA24 [pdf]</a> -->
									<p><a href="./About-ASA24.pdf" download aria-label="About ASA24 [pdf] - Download">About ASA24 [pdf]</a></p>
									<p><a :href="demoUrl" target="_blank" aria-label="ASA24 Demonstration Site - New Window">ASA24 Demonstration Site</a></p>
									<p><a :href="homeUrl" target="_blank" aria-label="ASA24 Respondent Website - New Window">ASA24 Respondent Website</a></p>
									<p><a href="https://epi.grants.cancer.gov/asa24/resources/faq.html" target="_blank" aria-label="Frequently Asked Questions (FAQs) - New Window">Frequently Asked Questions (FAQs)</a></p>
									<p><a href="https://list.nih.gov/cgi-bin/wa.exe?A0=ASA24-L" target="_blank" aria-label="Join ASA24 Listserv - New Window">Join ASA24 Listserv</a></p>
								</v-col>
								<v-col class="text-left resourcesCol">
									<p><a href="https://epi.grants.cancer.gov/asa24/resources/issues.html" target="_blank" aria-label="Known Issues and Workarounds - New Window">Known Issues and Workarounds</a></p>
									<p><a href="https://epi.grants.cancer.gov/asa24/register/" target="_blank" aria-label="Register a Study and Best Practices for Using ASA24 - New Window">Register a Study and Best Practices for Using ASA24</a></p>
									<p><a href="./QuickUserGuide-ASA24-ResearcherSite-FINAL.pdf" download type="pdf" aria-label="Researcher Site Quick User Guide [pdf] - Download">Researcher Site Quick User Guide [pdf]</a></p>
									<p><a href="https://epi.grants.cancer.gov/asa24/resources/hei.html" target="_blank" aria-label="Resources Related to the Healthy Eating Index (HEI) - New Window">Resources Related to the Healthy Eating Index (HEI)</a></p>
									<p><a href="https://epi.grants.cancer.gov/asa24/researcher/sample.html" target="_blank" aria-label="Sample Analysis Files and Data Dictionaries - New Window">Sample Analysis Files and Data Dictionaries</a></p>
								</v-col>
							</v-row>
            </v-card>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { utilityService } from '@/services/utilityService.js';
export default {
	name: 'LoginPage',
	data: () => {
		return {
			displayInEnglish: true,
			showGovernmentShutdownBanner: false
		}
	},
	computed: {
		homeUrl () {
			return utilityService.getLoginUrl(false);
		},
		demoUrl () {
			return utilityService.getDemoUrl();
		}
	},
	props: {},
	metaInfo: {
		title: 'Login'
	}
};
</script>
<style>
.loginRow {
padding: 12px;
font-size: 18px;
}
.resourcesCol {
	margin: 10px
}
.loginCard {
	width: 100%
}
</style>
